export default "__VITE_ASSET__7d0c5d8a__"